import { useState } from 'react'
import { DateTime } from 'luxon'
import NoData from '@components/NoData/NoData'
import SymbolCard from '@features/tradeCopy/components/SymbolCard'
import { TradeCopySymbolProps } from './interface'
import withTradeCopySymbol from './withTradeCopySymbol'

function TradeCopySymbol({ tradeCopyByBots, refetch }: TradeCopySymbolProps) {
  const [lastUpdate, setLastUpdate] = useState(
    DateTime.now().startOf('day').plus({ seconds: 1 })
  )

  return (
    <div className='py-[18px] px-[16px]'>
      <div className='text-xs font-light text-right text-gray-400'>
        Last update: {lastUpdate.toFormat('dd/MM/yyyy HH:mm:ss')}
      </div>
      {tradeCopyByBots?.length ? (
        <div className='grid grid-cols-1 gap-y-[9px] mt-[18px]'>
          {tradeCopyByBots.map(bot => (
            <SymbolCard key={bot.id} detail={bot} refetch={refetch} />
          ))}
        </div>
      ) : (
        <NoData />
      )}
    </div>
  )
}

export default withTradeCopySymbol(TradeCopySymbol)
